<template>
    <div class="radioBox">
        <div class="title">
            <span class="clearance">{{title}}</span>
            <span class="subtitle">{{subtitle}}</span>
        </div>
        <div class="boxSize">
            <el-row :gutter="24" type="flex" justify="space-between">
                <el-col :span="7" v-for="(item,index) in radioArr" :key="index">
                    <div class="box" :class="{boxActive:boxActive===item.index}" @click="changeActive(item.index)" v-loading="loading">
                        <div class="center">
                            <img :src="item.url" >
                        </div>
                        <div class="icon" v-if="boxActive===item.index"><img src="@/assets/icon_duigou.png" alt=""></div>
                    </div>
                    <span >{{item.content}}</span>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
name:'radioBox',
props:['radioArr','title','subtitle','pointLabel','pointIcon',],
data(){
    return {
        boxActive:'',
        loading: false,
    }
},
methods:{
    changeActive(index){
        this.boxActive = index;
        this.loading=true
        if(this.title == '图标样式'){
            this.$emit('changebuttonRadio',index, this.closeLoading);
        }else if(this.title == '按钮外观'){
            this.$emit('changeContent',index, this.closeLoading);
        }
    },
    defaultSelect(){
        if(this.title == '按钮外观'){
            if(this.pointIcon===0 && this.pointLabel!==0){
                this.boxActive = 2;
            }else if(this.pointIcon!==0 && this.pointLabel===0){
                this.boxActive = 0;
            }else{
                this.boxActive = 1;
            }
        }else if(this.title == '图标样式'){
            if(this.pointIcon=== 1 || this.pointIcon === 0){
                this.boxActive = 1;
            }else if(this.pointIcon===2){
                this.boxActive = 2;
            }else if(this.pointIcon===3){
                this.boxActive = 3;
            }
        }
    },
    closeLoading() {
        this.loading = false;
    }
},
mounted(){
    setTimeout(()=>{
        this.defaultSelect();
    },1000);
}
}
</script>
<style lang="scss" scoped>
.radioBox{
    margin: 20px 0px;
    .title{
        margin-bottom: 10px;
        .clearance{
            margin-right: 15px;
            color: #333333;
        }
        .subtitle{
            color: #999999 ;
        }
    }
    .boxSize{
        .boxActive{
            border: 1px solid #3DA1FF !important;
        }
        .box{
            position: relative;
            height: 120px;
            border-radius: 5px;
            border: 1px solid #DFE3E9;
            .center{
                position: absolute;
                top:50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
            .icon{
                position: absolute;
                bottom: -5px;
                right: 0;
            }
        }
    }
}
</style>